// extracted by mini-css-extract-plugin
export default {"contact-buttons":"contact-buttons--mp-WOcgc","contactButtons":"contact-buttons--mp-WOcgc","web-icon":"web-icon--mp-sgrrT","webIcon":"web-icon--mp-sgrrT"};